import { render } from "./loginSignup.vue?vue&type=template&id=7b81e49a"
import script from "./loginSignup.vue?vue&type=script&lang=js"
export * from "./loginSignup.vue?vue&type=script&lang=js"

import "./loginSignup.vue?vue&type=style&index=0&id=7b81e49a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__